<template>
  <div class="w-full" :class="parentContainer">
    <SelectorsMain
      :options="options"
      name="date"
      value-field="id"
      v-model="dateFilter"
      unique-key="id"
      :title="$t('common.select_date')"
      max-width="md:min-w-[192px] max-w-full w-full "
      :search-field="false"
      :placeholder="placeholder ? placeholder : $t('common.select_date')"
      label="name"
      :has-left="false"
      parent-container="w-full"
      :has-selected-tick="hasSelectedTick"
      overflow-visible
      :input-text-class="inputTextClass"
      :clear-icon-class="clearIconClass"
      :placeholder-class="placeholderClass"
      :container-class="containerClass"
      :is-default-filter-applied="isFilterApplied"
      @input="onUpdateSelection"
    >
      <template #icon>
        <slot name="icon"></slot>
      </template>
      <template #option="{ option, closeMenu }">
        <div
          class="flex items-center w-full h-full"
          v-if="option.id == 'this_week'"
          @click="showCalendar('this_week')"
        >
          <span class="text-base">{{ option.name }}</span>
        </div>
        <div
          v-else-if="option.id == 'last_months'"
          class="flex items-center w-full h-full"
          @click="showCalendar('last_months')"
        >
          <span class="text-base">{{ option.name }}</span>
        </div>
        <div
          v-else
          class="flex items-center w-full h-full"
          @click="hasSelectedTick = false"
        >
          <Datepicker
            @update-date="(e) => setDates(e, closeMenu)"
            @has-open="onOpen"
            :title="option.name"
            :key="updateKey"
            :default-date="defaultDate"
            title-class="text-black hover:text-primary"
          />
        </div>
      </template>
    </SelectorsMain>
  </div>
</template>
<script setup>
import { useTranslation } from "i18next-vue";
import { useAppStore } from "~/store/app";

const { t } = useTranslation();
const emit = defineEmits();
const appStore = useAppStore();

const props = defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  modelValue: {
    type: Object,
    default: {
      fromdate: "",
      todate: "",
    },
  },
  parentContainer: {
    type: String,
    default: "",
  },
  containerClass: {
    type: String,
    default:
      "focus:border-primary bg-[#FFFFFF] border-[#646465] bg-opacity-[0.06]",
  },
  placeholderClass: {
    type: String,
    default: "text-white text-opacity-70",
  },
  inputTextClass: {
    type: String,
    default: "text-white",
  },
  clearIconClass: {
    type: String,
    default: "text-white",
  },
});

const dateFilter = ref(null);
const closeMenuFun = ref(null);
const isFilterApplied = ref(false);

const hasSelectedTick = ref(true);
const datePicker = ref(null);
const updateKey = ref(0);
const defaultDate = ref({
  start: "",
  end: "",
});

const state = ref(props.modelValue);

watch(
  dateFilter,
  (newValue, oldValue) => {
    if (newValue == "custom_date") {
      hasSelectedTick.value = false;
      if (!defaultDate.value.start) {
        dateFilter.value = oldValue;
      }
    } else if (!newValue) {
      setDefaultDate({
        start: "",
        end: "",
      });
      emit("update:modelValue", {
        fromdate: "",
        todate: "",
      });
    } else {
      if (appStore.isMobile) {
        showCalendar(newValue, true);
      }
      hasSelectedTick.value = true;
    }
  },
  { deep: true }
);

const onUpdateSelection = () => {
  if (dateFilter.value == "custom_date") {
    if (appStore.isMobile) {
      applyDates();
    }
  }
};

const options = ref([
  {
    name: t("common.this_week"),
    id: "this_week",
  },
  {
    name: t("common.last_months", {
      month: "3 ",
      interpolation: { prefix: "[:", suffix: "]" },
    }),
    id: "last_months",
  },
  {
    name: t("common.custom_date"),
    id: "custom_date",
    hasManualApply: true,
  },
]);
function setDefaultDate(val) {
  defaultDate.value.start = val.start;
  defaultDate.value.end = val.end;
}
function onOpen(val) {
  if (!defaultDate.value.start && val) {
    isFilterApplied.value = false;
  } else if (val) {
    isFilterApplied.value = false;
  }
}

function showCalendar(type, filterApplied = false) {
  isFilterApplied.value = true;
  hasSelectedTick.value = true;
  if (type == "last_months") {
    let d = new Date(new Date().setMonth(new Date().getMonth() - 3));
    state.fromdate = d.toISOString().slice(0, 10);
    state.todate = new Date().toISOString().slice(0, 10);
  } else {
    var curr = new Date();
    var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
    var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
    state.fromdate = firstday.toISOString().slice(0, 10);
    state.todate = lastday.toISOString().slice(0, 10);
  }
  setDefaultDate({
    start: "",
    end: "",
  });
  if (!appStore.isMobile || filterApplied) {
    emit("update:modelValue", {
      fromdate: state.fromdate,
      todate: state.todate,
    });
  }
}

function applyDates() {
  emit("update:modelValue", {
    fromdate: state.fromdate,
    todate: state.todate,
  });

  if (closeMenuFun.value) {
    closeMenuFun.value();
  }
  updateKey.value++;
}

function setDates(e, closeMenu) {
  closeMenuFun.value = closeMenu;
  hasSelectedTick.value = true;
  if (e.start) {
    state.fromdate = new Date(e.start).toISOString().split("T")[0];
    state.todate = new Date(e.end).toISOString().split("T")[0];
  } else {
    state.fromdate = "";
    state.todate = "";
  }
  isFilterApplied.value = true;
  setDefaultDate(e);

  if (!appStore.isMobile) {
    applyDates();
    if (!dateFilter.value) {
      dateFilter.value = "custom_date";
    }
  }
}
</script>